import React, {Component} from "react"
import {convertToDisplayFormat, formatInLocalTimeZone, format, parse} from "../../../util/DateUtil"
import {COGOLAND_SESSION_DATE_FORMAT} from "../../../constants"
import {ControlLabel, Form, FormControl, FormGroup, Label} from "react-bootstrap"
import Button from "../../../components/Button"
import moment from "moment"
import "twix"

class SessionDateFrom extends Component {

  constructor() {
    super()
    this.state = {
      edit: false,
      changed: false,
      newDate: undefined,
    }
  }

  render() {


    const formatMessage = this.props.intl.formatMessage

    const lower = this.props.bounds[0]
    const upper = this.props.bounds[1]

    const startDate = lower ? parse(lower).add(1, 'days') : moment().add(-14, 'days').startOf('day')
    const endDate = upper ? parse(upper).add(-1, 'days') : moment(startDate).add(14, 'days').startOf('day')

    const dateList = [startDate]
    while (_.last(dateList).isBefore(endDate)) {
      dateList.push(moment(_.last(dateList)).add(1, 'days'))
    }


    const formatDate = str => convertToDisplayFormat(str, COGOLAND_SESSION_DATE_FORMAT)

    const trigger = <a onClick={() => {
      this.setState({edit: true})

    }}>{formatDate(this.props.value)}</a>
    const form = (<div className="row">
      <div className="col-xs-12 p-sm">
        <Form>
          <FormGroup controlId="formControlsSelect">
            <FormControl
              onChange={(e) => {
                this.setState({changed: e.target.value !== this.props.value, newDate: e.target.value})
              }}
              componentClass="select" placeholder="select">
              {dateList.map(date => (
                <option
                  selected={this.props.value === format(date)}
                  value={format(date)}>
                  {formatInLocalTimeZone(date, COGOLAND_SESSION_DATE_FORMAT)}
                </option>
              ))}
            </FormControl>
          </FormGroup>
        </Form>
      </div>
      <div className="col-xs-2">
        <Button
          loading={this.state.saving}
          disabled={!this.state.changed}
          onClick={() => {
            this.setState({saving: true})
            if (this.props.onChange) {
              this.props.onChange(parse(this.state.newDate))
            }
          }}>{formatMessage({id:'save'})}</Button>
      </div>
      <div className="col-xs-2">
        <Button onClick={() => {
          this.setState({edit: false})
        }}>{formatMessage({id:'cancel'})}</Button>
      </div>
    </div>)

    return (
      <div>
        {this.state.edit ? form : trigger}
      </div>
    )
  }
}

export default SessionDateFrom



// WEBPACK FOOTER //
// ./src/routes/cogoland/component/SessionDateFrom.js